import cn from 'classnames';

interface PropTypes {
  tags?: Array<string>;
}
const ProductTags: React.FC<PropTypes> = ({ tags }) => {
  if (!tags) return null;

  return (
    <>
      {tags.map((tag, index) => (
        <p
          key={tag}
          className={cn(
            ' text-sm  leading-3 text-primary-main',
            tags.length - 1 !== index && 'border-r border-other-black pr-2'
          )}
        >
          {tag}
        </p>
      ))}
    </>
  );
};

export default ProductTags;
